import { useState, useRef, useEffect, useContext } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaPaperPlane } from 'react-icons/fa';
import '../../../assets/css/Customer/CustomerChat/CustomerChat.css';
import AppContext from "../../../context/AppContext";
import axios from "axios";

const DriverChat = () => {
    const navigate = useNavigate();
    const { baseUrl, authToken, selectedRideforFindingDriver } = useContext(AppContext);

    const [message, setMessage] = useState('');
    const [messages, setMessages] = useState([]);
    const [conversationId, setConversationId] = useState(null);
    const messagesEndRef = useRef(null);
    const inputRef = useRef(null);

    const createConversation = () => {
        const formData = new FormData();
        formData.append("tdcustomer_id", selectedRideforFindingDriver?.tdcustomer_id);
        formData.append("tddriver_id", selectedRideforFindingDriver?.tddriver_id);
        formData.append("tdride_id", selectedRideforFindingDriver?.id);

        axios.post(`${baseUrl}/driver/conversation/createConversation`, formData, { 
            headers: { Authorization: `Bearer ${authToken}` },
        }).then((response) => {
            if (response.data.success === true) {
                setConversationId(response.data.conversation.id);
                fetchMessages(response.data.conversation.id);
            }
        }).catch((error) => console.log(error));
    };

    const fetchMessages = (conversationId) => {
        const formData = new FormData();
        formData.append("tdconversation_id", conversationId);

        axios.post(`${baseUrl}/driver/conversation/fetchMessages`, formData, {
            headers: { Authorization: `Bearer ${authToken}` },
        }).then((response) => {
            if (response.data.success === true) {
                setMessages(response.data.messages);
            }
        }).catch((error) => console.log(error));
    };

    const handleSend = () => {
        if (!message.trim() || !conversationId) return;

        const formData = new FormData();
        formData.append("tdconversation_id", conversationId);
        formData.append("message", message.trim());

        axios.post(`${baseUrl}/driver/conversation/sendMessage`, formData, {
            headers: { Authorization: `Bearer ${authToken}` },
        }).then((response) => {
            if (response.data.success === true) {
                setMessages(prev => [...prev, response.data.chat]);
                setMessage('');
                inputRef.current?.focus();
            }
        }).catch((error) => console.log(error));
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSend();
        }
    };

    useEffect(() => {
        createConversation();
    }, []);

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    return (
        <div className="customerChat-wrapper">
            <div className="customerChat-header">
                <button className="customerChat-back-btn" onClick={() => navigate(-1)}>
                    <FaArrowLeft />
                </button>
                <p className="customerChat-header-name">Customer Chat</p>
                <div className="customerChat-header-spacer" />
            </div>

            <div className="customerChat-messages">
                {messages.length === 0 && (
                    <p className="customerChat-empty-hint">write message here</p>
                )}

                {messages.map((msg) => {
                    const isDriver = msg.Sender === "tddriver";
                    return (
                        <div key={msg.id} className={`customerChat-row ${isDriver ? "customerChat-row--user" : "customerChat-row--driver"}`}>
                            <div className="customerChat-col">
                                <div className={`customerChat-bubble ${isDriver ? "customerChat-bubble--user" : "customerChat-bubble--driver"}`}>
                                    {msg.message}
                                </div>
                                <span className="customerChat-time">
                                    {new Date(msg.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                </span>
                            </div>
                        </div>
                    );
                })}
                <div ref={messagesEndRef} />
            </div>

            <div className="customerChat-input-bar">
                <InputGroup className="customerChat-input-group">
                    <Form.Control
                        ref={inputRef}
                        type="text"
                        placeholder="Message likhein..."
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        onKeyDown={handleKeyDown}
                        className="customerChat-input"
                    />
                </InputGroup>
                <button
                    className={`customerChat-send-btn ${message.trim() ? "customerChat-send-btn--active" : ""}`}
                    onClick={handleSend}
                    disabled={!message.trim()}
                >
                    <FaPaperPlane />
                </button>
            </div>
        </div>
    );
};

export default DriverChat;